import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=2921e670&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=2921e670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921e670",
  null
  
)

export default component.exports